// Select2

// console.log('11');

import * as select2 from "select2";

// Select2
jQuery(function($){
	$('select').select2({
		minimumResultsForSearch: Infinity,
		width: ''
	});
});